import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { updatePreferences } from 'lib/context/TableContext/helper';
import { cn, formatLargeNumber } from 'lib/helpers/utility';

import Button from '../Button/Button';
import Popover from '../Popovers/Popover/Popover';
import Typography from '../Typography/Typography';

const limitOptions = [
  { label: '15', value: 15 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
  { label: '500', value: 500 }
];

export const CustomStatusBarCount = ({ count = 0, page = 1, pagination }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { name, colDefs, limit = 25, setLimit, setPage } = useTableContext();

  const totalPages = Math.ceil(count / limit); // Found a bug where we can filter if we are based on a page where the items fetched cannot reach that fill out of pages
  // therefore we return items total to it's extend point i.e TotalPages | CONSULT BEFORE REMOVING!

  const start = page > totalPages ? totalPages : (page - 1) * (pagination ? limit : count) + 1;

  const onLimitChangeHandler = async (value) => {
    setLimit(value);
    setPage(1);
    await updatePreferences({ navigate, cols: colDefs, limit: value, queryClient, name });
    queryClient.invalidateQueries(['table-limit']);
  };

  return (
    <div className="flex h-full items-center justify-end gap-1 whitespace-nowrap p-0 pr-[38px]">
      {count > 0 ? (
        <>
          <Typography variant="label" size="small" weight="medium" color="neutral-700">
            {formatLargeNumber(start)}
          </Typography>
          <Typography variant="label" size="small" color="neutral-500">
            to
          </Typography>
          <Popover
            customButtonTrigger={({ open }) => (
              <Button
                variant="tertiary"
                size="small"
                text={limit}
                iconRight="chevron-down-linear"
                iconShade={700}
                color="neutral"
                iconSize={16}
                className={cn('h-6 w-fit bg-white py-0 pl-2 pr-1', open && 'bg-neutral-100')}
              />
            )}
            optionArrowIcon="chevron-right-filled"
            optionIconColor="neutral"
            iconsShade={700}
            options={limitOptions}
            onOptionClick={(option, handleClose) => {
              onLimitChangeHandler(option.value);
              handleClose();
            }}
            textClassName="text-neutral-900"
            isFixed
            position="top"
          />
          <Typography variant="label" size="small" color="neutral-500">
            of
          </Typography>
          <Typography variant="label" size="small" weight="medium" color="neutral-700">
            {formatLargeNumber(count)}
          </Typography>
        </>
      ) : (
        <span aria-hidden="true" />
      )}
    </div>
  );
};
